<script>
  export default {
    name: "dol-mind-node",
    props: {
      data: {type: Object, default: () => {}},
      parent: {type: Object, default: null},
      borderFlag: {type: Boolean, default: true},
      level: {type: Number, default: 1},
      padding: {type: String},
    },
    data(){
      return {
        showChildren: true
      };
    },
    render: function (createElement) {
      let renderNode;
      if(typeof this.$scopedSlots.default === 'function'){
        renderNode = [ this.$scopedSlots.default({data: this.data, level: this.level, $parent: this.parent}) ];
      }else if(this.$slots.default){
        renderNode = this.$slots.default;
      }else{
        renderNode = [ createElement('span', this.data.name) ];
      }

      let children = [];
      this.data && this.data.children && this.data.children.forEach(item => {
        children.push(createElement(
          'dol-mind-node',
          {
            props:{
              data: item,
              borderFlag: this.borderFlag,
              level: this.level + 1,
              padding: this.padding,
              parent: this.data,
            },
            scopedSlots: this.$scopedSlots
          },
        ));
      });

      let nodeEl = [];

      nodeEl.push(createElement('div', { class:'block', style:{ padding: this.padding } }, renderNode ));
      if(!this.data.isLeaf){
        nodeEl.push(createElement(
          'div',
          {
            class: 'dol-mind__toggle-switch',
            on: {
              click: this.toggleChildren
            }
          },
          [
            createElement('span', this.showChildren?'-':'+' ),
          ]
        ));
      }
      nodeEl.push(createElement(
        'div',
        {
          class: 'children',
          style: {
            display: this.showChildren?'block':'none',
          }
        },
        children
      ));

      return createElement(
        'div',
        {
          class: {
            'dol-mind-node': true,
            'dol-mind-node__last-node': this.data.isLeaf,
            'dol-mind-node__border': this.borderFlag,
          },
        },
        nodeEl
      );
    },
    methods: {
      toggleChildren(){
        this.showChildren = !this.showChildren;
      }
    }
  }
</script>
